import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ListView = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M2.5 4C2.5 3.44772 2.94772 3 3.5 3H13.5C14.0523 3 14.5 3.44772 14.5 4C14.5 4.55228 14.0523 5 13.5 5H3.5C2.94772 5 2.5 4.55228 2.5 4Z"
        fill="#2D425B"
        fillOpacity="0.05"
      />
      <path
        d="M2.5 8C2.5 7.44772 2.94772 7 3.5 7H10C10.5523 7 11 7.44772 11 8C11 8.55228 10.5523 9 10 9H3.5C2.94772 9 2.5 8.55228 2.5 8Z"
        fill="#2D425B"
        fillOpacity="0.05"
      />
      <path
        d="M2.5 12C2.5 11.4477 2.94772 11 3.5 11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H3.5C2.94772 13 2.5 12.5523 2.5 12Z"
        fill="#2D425B"
        fillOpacity="0.05"
      />
      <path
        d="M2.5 4C2.5 3.44772 2.94772 3 3.5 3H13.5C14.0523 3 14.5 3.44772 14.5 4C14.5 4.55228 14.0523 5 13.5 5H3.5C2.94772 5 2.5 4.55228 2.5 4Z"
        stroke={color}
      />
      <path
        d="M2.5 8C2.5 7.44772 2.94772 7 3.5 7H10C10.5523 7 11 7.44772 11 8C11 8.55228 10.5523 9 10 9H3.5C2.94772 9 2.5 8.55228 2.5 8Z"
        stroke={color}
      />
      <path
        d="M2.5 12C2.5 11.4477 2.94772 11 3.5 11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H3.5C2.94772 13 2.5 12.5523 2.5 12Z"
        stroke={color}
      />
    </svg>
  )
})

export default ListView
